export default __webpack_public_path__ + "static/media/customer-review.43b22d73.svg";